import Link from "next/link";

const AnimatedButton = ({ label = "Button", className = "", ...props }) => {
  const chars = label.split("");
  const cardItems = [
    { title: "Consumer login", link: 'https://kuppamresco.org/ConsumerDashboard/login.jsp' },
    { title: "Dept mail login", link: 'https://email.kuppamresco.org/' },
    { title: "e-office login ", link: 'https://cttr.eoffice.ap.gov.in/SSOComponent/auth.php' },
  ]
  return (
    <div className="relative group inline-block">
      <div className="
        absolute right-0 top-9
        bg-white shadow-lg rounded-lg p-3 w-48
        opacity-0 scale-95 pointer-events-none
        transition-all duration-300 ease-out
        group-hover:opacity-100 group-hover:scale-100 group-hover:pointer-events-auto
        z-50
      ">
        {cardItems.map((item, index) => (
          <div key={index}>
            <Link href={item.link} target="_blank" className="py-1 text-lg font-semibold">
              {item.title}
            </Link>
          </div>
        ))}
      </div>
      <button
        className={`relative overflow-hidden min-w-11 px-3 sm:py-0.5 2xl:px-5 rounded-lg text-lg 2xl:text-xl font-semibold bg-white text-green-11 group ${className}`}
        {...props}
      >
        {/* Sliding background */}
        <div
          className={`absolute inset-0 grid place-content-center bg-white text-green-11 transition-transform duration-200 ease-[cubic-bezier(.87,0,.13,1)] group-hover:translate-y-full z-10`}
        >
          {label}
        </div>
        {/* Animated letters */}
        <div className="inline-flex relative z-20">
          {chars.map((char, idx) => (
            <span
              key={idx}
              className={`opacity-0 transition-all duration-200 ease-[cubic-bezier(.87,0,.13,1)] group-hover:opacity-100 group-hover:translate-y-0 ${idx % 2 === 0 ? "-translate-y-4" : "translate-y-4"
                }`}
              style={{ transitionDelay: `${idx * 0.1}s` }}
            >
              {char}
            </span>
          ))}
        </div>
      </button>
    </div>
  );
};
export default AnimatedButton;
